import { useEffect }            from 'react';
import helloIcon                from 'assets/images/chatbot/hello.svg';
import AuthorizationContext     from 'auth/keycloak-instance';
import useTranslate             from 'app/common/hooks/translate';
import {
    useSelector,
    shallowEqual
}                               from 'react-redux';

const WIDGET_SRC        = 'https://ai-assets.simprasuite.com/distribution/simpra-chat.iife.js';
const WIDGET_SCRIPT_ID  = 'simpra-chat-widget-script';
const WIDGET_ROOT_ID    = 'simpra-chat-widget-root';

// languages the widget itself ships translations for; the rest fall back to English
const WIDGET_LANGUAGES  = [ 'tr', 'en', 'fr', 'es', 'ru', 'ar', 'hu', 'az', 'de', 'hr', 'pl', 'kk' ];

const EMBED_IDS         = 'b4534651-4181-405d-8ef6-d115cec3f22d;9f3c1565-d6ae-4bd9-8fa6-fae5fdb5ec36;c8ab43a2-4cf9-4c7b-a190-05df3b0677ea;17dc1671-639c-4b37-b4ce-e1070c138049;TODO';
const EMBED_TITLES      = 'POS;Inventory;Link;Check & Place;Loyalty';

const FALLBACK_USERNAME = 'Demo User';

// an incomplete profile falls back to a placeholder rather than an email address,
// which has no business reaching the chat backend
const getUsername = () => {
    const profile = AuthorizationContext.user.profile;

    return [ profile?.firstName, profile?.lastName ].filter(Boolean).join(' ')
        || FALLBACK_USERNAME;
};

const removeWidget = () => {
    document.getElementById(WIDGET_SCRIPT_ID)?.remove();
    document.getElementById(WIDGET_ROOT_ID)?.remove();
};

const ChatbotWidget = () => {
    const t     = useTranslate();
    const redux = useSelector( state => ({
            displayLanguage             : state.provider.displayLanguage
        }), shallowEqual
    );

    useEffect(() => {
        // the button label follows the language the widget actually renders in,
        // so it never says one thing while the panel speaks another
        const language = WIDGET_LANGUAGES.includes(redux.displayLanguage)
                            ? redux.displayLanguage
                            : 'en';

        const attributes = {
            'data-embeds-id'        : EMBED_IDS,
            'data-embeds-title'     : EMBED_TITLES,
            'data-username'         : getUsername(),
            'data-language'         : language,
            'data-position'         : 'bottom-right',
            'data-chat-icon'        : helloIcon,
            'data-assistant-icon'   : helloIcon,
            'data-brand-image-url'  : helloIcon,
            'data-button-color'     : '#fedd00',
            'data-button-text'      : t('Chatbot_Button_Label', language),
            'data-assistant-name'   : 'Simpra AI',
        };

        // a stale widget from a previous language would otherwise stack up
        removeWidget();

        const script    = document.createElement('script');
        script.id       = WIDGET_SCRIPT_ID;

        Object.entries(attributes).forEach( ([ name, value ]) => script.setAttribute(name, value) );

        // src last: the bundle reads its own attributes off document.currentScript as it runs
        script.src = WIDGET_SRC;
        document.body.appendChild(script);

        // the bundle exposes no re-init api, so switching language tears it down and mounts it again
        return removeWidget;
    }, [ redux.displayLanguage, t ]);

    return null;
};

export default ChatbotWidget;
